export default "__VITE_ASSET__ecMpo7kd__"